// ----------------------------------------------------------------------
import ActiveIcon from "assets/icons/active.svg";
export default function Tabs(theme) {
  return {
    MuiTab: {
      defaultProps: {
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          minWidth: 120,
          display: "flex",
          justifyContent: "start",
          alignItems: "start",
          padding: "0 15px",
          fontSize: 16,
          fontWeight: 500,
          textTransform: "unset",
          overflow: "visible",
          marginRight: theme.spacing(3),
          fontFamily: "Futura",
          fontWeight: 500,
          ":after": {
            content: "''",
            position: "absolute",
            width: "5px",
            height: "5px",
            borderRadius: "10rem",
            backgroundColor: theme.palette.primary.light,
            top: 8,
            left: "-2.2px",
          },
          ":not(:last-child)": {
            ":before": {
              content: "''",
              position: "absolute",
              borderLeft: "1px solid",
              borderColor: theme.palette.grey[500],
              height: "110%",
              top: 8,
              left: 0,
            },
          },
          "&.Mui-selected": {
            color: theme.palette.primary.main,
            ":after": {
              width: "13px",
              height: "13px",
              borderRadius: "10rem",
              background: `center/contain no-repeat url(${ActiveIcon})`,
              top: 4,
              left: "-6px",
            },
          },
        },
        labelIcon: {
          minHeight: 48,
          flexDirection: "row",
          "& > *:first-of-type": {
            marginBottom: 0,
            marginRight: theme.spacing(1),
          },
        },
        wrapper: {
          flexDirection: "row",
          whiteSpace: "nowrap",
        },
        textColorInherit: {
          opacity: 1,
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: "50%",
        },
      },
    },
  };
}
